import { Colors, Lightning, Router } from '@lightningjs/sdk'
import Equalizer from '../../components/Equalizer'
import { appSettings } from '../../lib/AppSettings'
import { formatDate } from '../../lib/AppHelpers'
import Loader from '../../components/Loader2'

export default class nowPlaying extends Lightning.Component {
  static _template() {
    return {
      w: 160,
      h: 115,
      zIndex: 10,
      BgBar: { w: 0, h: 115, x: 465, mountX: 1, rect: true, color: Colors('lBlue').get() },
      Equalizer: {
        x: 95,
        w: 46,
        h: 46,
        y: 49,
        mountY: 0.5,
        visible: false,
        zIndex: 5,
        type: Equalizer,
        barColor: Colors('lBlue').get(),
      },
      Loader: {
        x: 95,
        w: 46,
        h: 46,
        y: 49,
        mountY: 0.5,
        alpha: 0,
        type: Loader,
        zIndex: 5,
        loaderSize: { width: 49, height: 49 },
      },
      MenuLabel: {
        x: 170,
        h: 115,
        Label: {
          w: 280,
          h: 0,
          color: this.bindProp('labelColor'),
          text: {
            text: this.bindProp('menuLabel'),
            verticalAlign: 'middle',
            fontFace: this.bindProp('labelFont'),
            fontSize: 25,
            lineHeight: 34,
            maxLines: 2,
            wordWrapWidth: 270,
            wordWrap: false,
          },
        },
        NowPlayingSong: {
          w: 280,
          h: 30,
          y: 50,
          color: this.bindProp('labelColor'),
          text: {
            text: this.bindProp('npSong'),
            fontFace: 'OpenSansLight',
            fontSize: 20,
            lineHeight: 25,
            maxLines: 1,
          },
        },
        NowPlayingArtist: {
          w: 280,
          h: 30,
          y: 50,
          color: this.bindProp('labelColor'),
          text: {
            text: this.bindProp('npArtist'),
            fontFace: 'OpenSansLight',
            fontSize: 20,
            lineHeight: 25,
            maxLines: 1,
          },
        },
      },
    }
  }
  _firstActive() {
    this.patch({
      menuIcon: '',
      // menuLabel: appSettings.currentBrand.name,
      labelFont: 'OpenSansRegular',
      labelColor: Colors('lBlue').get(),
    })
  }
  get isPlaying() {
    return this._isPlaying
  }

  _init() {
    this._isPlaying = false
    this._streamType = ''
    this._service = ''
  }
  OnGpStateChange({ state, playbuttonState }) {
    const showLoader = state === 'LoadStart' || state === 'Seeking' || state === 'Waiting'
    this.tag('Loader').alpha = showLoader ? 1 : 0.01
    this.tag('Equalizer').alpha = showLoader ? 0.01 : 1
    if (playbuttonState === 'playing' || state === 'Seeking' || state === 'Waiting') {
      this._isPlaying = true
      const reloadMetadata =
        this._streamType !== 'show' && (state === 'LoadStart' || this._streamType === 'track')
      this.showHideEQText(true, reloadMetadata)

      this.tag('Equalizer').startAnimation()
    } else if (playbuttonState === 'stop' || playbuttonState === 'pause') {
      this._service = ''
      this._isPlaying = false
      this._streamType = ''
      this.showHideEQText(false, playbuttonState === 'pause')

      this.tag('Equalizer').stopAnimation()
    }
  }
  radioMessageNowPlaying() {
    this._isPlayingRadio = true
    if (
      this._isPlaying &&
      this._nowPlayingData &&
      this._nowPlayingData.currentPlaying &&
      (this._nowPlayingData.currentPlaying.type === 'show' ||
        this._nowPlayingData.currentPlaying.type === 'track')
    ) {
      const data = appSettings.nowPlaying
      if (this._service !== data.service) {
        this._service = data.service
        this._nowPlayingData = data
        this._currentShowData = data.currentShow
      }
      this._streamType = this._nowPlayingData.currentPlaying.type

      const { artist, title, name } = data.currentPlaying,
        { csArtist, csTitle, csName } = data.currentShow,
        npArtist = artist || csArtist || '',
        npSong = title || name || csTitle || csName || ''
      this.patch({
        // Equalizer: {visible: !!show},
        MenuLabel: {
          visible: true,
          y: npSong || npArtist ? (npSong && npArtist ? 0 : 20) : 40,
          // Label: {text: {text: menuLabel, wordWrap: false}},
          NowPlayingSong: { visible: npSong ? 1 : 0, text: { text: npSong } },
          NowPlayingArtist: {
            visible: npArtist ? 1 : 0,
            y: npSong ? 85 : 50,
            text: { text: npArtist },
          },
        },
      })
    }
  }

  showHideEQText(show, reload = true) {
    if (reload || !this._nowPlayingData) {
      this._nowPlayingData = appSettings.nowPlaying
      this._streamType = this._nowPlayingData.currentPlaying.type
    }
    this._currentShowData = this._nowPlayingData.currentShow
    const currentlyPlaying = this._nowPlayingData ? this._nowPlayingData.currentPlaying : ''
    if (currentlyPlaying) {
      let menuLabel, npArtist, npSong
      switch (currentlyPlaying.type) {
        case 'podcast':
          menuLabel = currentlyPlaying.title || ''
          npArtist = currentlyPlaying.podcast.title || ''
          npSong = '' // currentlyPlaying.podcast.itunesAuthor || ''
          break
        case 'catchup':
          menuLabel = currentlyPlaying.title || ''
          npArtist =
            (currentlyPlaying.startDate &&
              formatDate(new Date(currentlyPlaying.startDate), {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
              })) ||
            ''
          npSong = ''
          break
        case 'playlist':
          menuLabel = currentlyPlaying.title || ''
          npArtist = ''
          npSong = ''
          break
        case 'show':
          //  menuLabel = appSettings.currentBrand.name || ''
          menuLabel = this._nowPlayingData.currentShow.brandName || ''
          npArtist =
            (this._nowPlayingData.currentShow && this._nowPlayingData.currentShow.name) ||
            this._nowPlayingData.currentShow.shortName ||
            ''
          npSong = ''
          break
        default:
          // for track
          menuLabel = appSettings.currentBrand.name || ''
          npArtist = currentlyPlaying.artist || ''
          npSong = currentlyPlaying.title || ''
          break
      }
      if (
        this._isPlayingRadio === true &&
        (currentlyPlaying.type === 'podcast' ||
          currentlyPlaying.type === 'catchup' ||
          currentlyPlaying.type === 'playlist')
      ) {
        let _activePage = Router.getActivePage()
        if (_activePage.widgets && _activePage.widgets.globalplayer) {
          _activePage.widgets.globalplayer.closeWebSocket(true)
        }
        this._isPlayingRadio = false
      }
      this.patch({
        Equalizer: { visible: !!show },
        MenuLabel: {
          visible: !!show,
          y: npSong || npArtist ? (npSong && npArtist ? 0 : 20) : 40,
          Label: { text: { text: menuLabel, wordWrap: currentlyPlaying.type === 'playlist' } },
          NowPlayingSong: { visible: npSong ? 1 : 0, text: { text: npSong } },
          NowPlayingArtist: {
            visible: npArtist ? 1 : 0,
            y: npSong ? 85 : 50,
            text: { text: npArtist },
          },
        },
      })
    }

    // this.tag("Label").y = show === true ? 15 : 40;
  }

  _focus() {
    this.patch({
      BgBar: {
        smooth: { w: [465, { duration: 0.3 }] },
      },
      smooth: {
        labelColor: [Colors('white').get(), { duration: 0.3 }],
      },
    })
    this.tag('Equalizer').barColor = Colors('white').get()
  }

  _unfocus() {
    this.patch({
      BgBar: {
        smooth: { w: [0, { duration: 0.3 }] },
      },
      smooth: {
        labelColor: [Colors('lBlue').get(), { duration: 0.3 }],
      },
    })
    this.tag('Equalizer').barColor = Colors('lBlue').get()
  }

  _handleEnter() {
    let _crntPlaying =
      this._nowPlayingData && this._nowPlayingData.currentPlaying
        ? this._nowPlayingData.currentPlaying
        : null
    if (
      _crntPlaying &&
      _crntPlaying.type === 'catchup' &&
      Router.getActiveHash() !== `catchupDetails/${_crntPlaying.chatchId}/${_crntPlaying.id}`
    ) {
      Router.navigate(`catchupDetails/${_crntPlaying.chatchId}/${_crntPlaying.id}`, {
        background: _crntPlaying.background,
      })
    } else if (
      _crntPlaying &&
      _crntPlaying.type === 'playlist' &&
      Router.getActiveHash() !== `playlistDetails/${_crntPlaying.id}`
    ) {
      Router.navigate(`playlistDetails/${_crntPlaying.id}`)
    } else if (
      _crntPlaying &&
      _crntPlaying.type === 'podcast' &&
      Router.getActiveHash() !== `podcasts/episodes/${_crntPlaying.id}`
    ) {
      Router.navigate(`podcasts/episodes/${_crntPlaying.id}`)
    } else if ((_crntPlaying && _crntPlaying.type === 'show') || _crntPlaying.type === 'track') {
      Router.navigate(`radio/${this._nowPlayingData.currentShow.brandName}`, { reload: true })
    } else {
      Router.restoreFocus()
    }
  }
}
